<!-- Main container for centering content -->
<div class="container-fluid callback-container">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="state-panel text-center">
    <div class="loader"></div>
    <p class="mt-3 text-muted">Authenticating to Qualix, please wait...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError" class="state-panel card shadow-sm">
    <div class="card-body text-center p-5">
      <div class="error-icon mb-3">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h2 class="card-title">Authentication Failed</h2>
      <p class="card-text text-muted mb-4">
        We couldn't complete the sign-in process. Please see the error below and choose an option.
      </p>

      <div class="alert alert-danger text-left">
        <strong>Error:</strong> {{ errorMessage }}
      </div>

      <div class="mt-4">
        <button (click)="retry()" class="btn btn-primary btn-md">
          <i class="fas fa-redo-alt mr-2"></i>Try Again
        </button>
        <button (click)="returnToLogin()" class="btn btn-outline-secondary btn-md ml-3">
          <i class="fas fa-sign-in-alt mr-2"></i>Return to Login
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="newUserError" class="state-panel card shadow-sm">
    <div class="card-body text-center p-5">
      <div class="error-icon mb-3">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h2 class="card-title">Customer Registration Required</h2>
      <p class="card-text text-sm mb-4">
        Please register as a customer to continue.
      </p>

      <!-- <div class="alert alert-danger text-left">
        <strong>Error:</strong> {{ errorMessage }}
      </div> -->

      <div class="mt-4 button-container">
       <button (click)="registerAsCustomer()" class="btn btn-primary btn-md">
          <i class="fa fa-user-plus mr-2"></i>Register as Customer
        </button>
        <button (click)="returnToLogin()" class="btn btn-outline-secondary btn-md ml-3">
          <i class="fas fa-sign-in-alt mr-2"></i>Return to Login
        </button>
      </div>
    </div>
  </div>
</div>

<style>
  .loader-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f8f9fa;
    /* A very light grey, matching bootstrap's default light bg */
    transition: opacity 0.5s ease-in-out;
  }

  .loader {
    border: 6px solid #e9ecef;
    /* A slightly darker grey */
    border-top: 6px solid #0d6efd;
    /* Bootstrap primary blue */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
  }

  .loader-text {
    margin-top: 20px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    color: #6c757d;
    /* Bootstrap secondary text color */
    font-size: 1.1em;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>